(function () {
  'use strict';

  function initBenefitsScroll(sectionEl) {
    var sectionId  = sectionEl.dataset.sectionId;
    var track      = document.getElementById('bsTrack-'      + sectionId);
    var stage      = document.getElementById('bsStage-'      + sectionId);
    var photoLayer = document.getElementById('bsPhotoLayer-' + sectionId);

    if (!track || !stage || !photoLayer) return;

    var photoSlides = photoLayer.querySelectorAll('.bs-photo-slide');
    var textSlides  = sectionEl.querySelectorAll('.bs-text-slide');
    var N = textSlides.length;

    if (!N) return;

    var ticking       = false;
    var resizeTicking = false;

    function update() {
      ticking = false;

      var rect       = track.getBoundingClientRect();
      var trackH     = track.offsetHeight;
      var stageH     = stage.offsetHeight;
      var scrollable = trackH - stageH;
      var scrolled   = -rect.top;
      var progress   = scrollable > 0 ? scrolled / scrollable : 0;
      progress = Math.max(0, Math.min(1, progress));

      var itemProgress = progress * Math.max(N - 1, 1);

      /* Photo crossfade */
      var idx0    = Math.floor(itemProgress);
      idx0 = Math.max(0, Math.min(N - 1, idx0));
      var frac    = itemProgress - idx0;
      if (idx0 === N - 1) frac = 0;
      var nextIdx = Math.min(idx0 + 1, N - 1);

      photoSlides.forEach(function (el) {
        var i  = parseInt(el.dataset.idx, 10);
        var op = 0;
        if (i === idx0)                             op = 1 - frac;
        else if (i === nextIdx && nextIdx !== idx0) op = frac;
        el.style.opacity = op;
      });

      /* Text push-transition */
      textSlides.forEach(function (el) {
        var i   = parseInt(el.dataset.idx, 10);
        var pos = i - itemProgress;
        if (i === N - 1) pos = Math.max(pos, 0); /* last slide stays at center */
        var distance   = Math.max(-1, Math.min(1, pos));
        var translateY = distance * 108;           /* 108% = fully offscreen */
        el.style.transform     = 'translateY(' + translateY + '%)';
        el.style.visibility    = Math.abs(distance) < 0.7  ? 'visible' : 'hidden';
        el.style.pointerEvents = Math.abs(distance) < 0.15 ? 'auto'    : 'none';
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    function onResize() {
      if (!resizeTicking) {
        resizeTicking = true;
        requestAnimationFrame(function () { resizeTicking = false; update(); });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    update(); /* set initial state on load */

    /* Shopify theme editor cleanup */
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(sectionEl)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
      }
    });
  }

  /* Init all instances on page load */
  function initAll() {
    document.querySelectorAll('.bs-section[data-section-id]').forEach(initBenefitsScroll);
  }

  /* Handle theme editor section:load (e.g. when user adds the section) */
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector('.bs-section[data-section-id]');
    if (sectionEl) initBenefitsScroll(sectionEl);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
